// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Qj-z","carouselContainer":"Rj-z","carouselContent":"Sj-z"};